import { Box, Typography } from '@mui/material'
import { PageHeaderProps } from './PageHeader.types'

export const PageHeader = ({ title, rightElement }: PageHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        minHeight: '36px',
      }}
    >
      <Typography variant="h2">{title}</Typography>
      {Boolean(rightElement) && rightElement}
    </Box>
  )
}
